import {DataObjectId, Hub} from 'yougile-model'
import {getAllowedMirroredHubs} from './get-allowed-mirrored-hubs'
import {getOldestHub} from './get-oldest-hub'

export const getAllowedMirroredOldestHub = (
  hub: Hub
): DataObjectId | undefined => {
  const hubs = getAllowedMirroredHubs(hub)
  if (!hubs) {
    return undefined
  }

  return getOldestHub(hubs)
}
